import { render, staticRenderFns } from "./AuthenStaff.vue?vue&type=template&id=5bffbaa2&scoped=true&"
import script from "./AuthenStaff.vue?vue&type=script&lang=js&"
export * from "./AuthenStaff.vue?vue&type=script&lang=js&"
import style0 from "./AuthenStaff.vue?vue&type=style&index=0&id=5bffbaa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bffbaa2",
  null
  
)

export default component.exports